import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import SendGridCRUDActions from '../actions/SendGridCRUDActions';
import { SendGridAccount } from '../model/SendGridModel';

export type SendGridState = {
  busy: boolean;
  accounts: {
    [key: string]: SendGridAccount;
  };
};

const initialState: SendGridState = {
  busy: false,
  accounts: {},
};

export default function sendGrid(state = initialState, action: any) {
  switch (action.type) {
    case SendGridCRUDActions.busyAction:
      return setBusy(state);
    case SendGridCRUDActions.unbusyAction:
      return setUnBusy(state);
    case SendGridCRUDActions.retrievedAllAccounts:
      return {
        ...state,
        busy: false,
        accounts: action.payload,
      };
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
